const blank = (overrides = {}) => ({
  financial_year: [],
  location_id: [],
  sublocation_id: [],
  category: [],
  sub_category: [],
  kpi: [],
  displayPeriods: [],
  ...overrides,
});


// ───────────────── SUMMARY CONFIGS ─────────────────

const summaryConfigs = {
  Employment: {
    module: "Employment",
    cards: [

      {
        id: "full_time_employees",
        title: "Full-time Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "up",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["metric_name"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Full-time Employees",
            formula: "{{DC1}}",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Full-time Employee (in Number)"],
                kpi: ["Full-time Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },

      {
        id: "contract_employees",
        title: "Contract Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "neutral",
        group_by: ["kpi"],
        comparison: { type: "previous_period", field: "financialYear" },    
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Contract Employees",
            formula: "{{DC1}}",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Contract Employee (in Number)"],
                kpi: ["Contract Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      },

      {
        id: "outsource_employees",
        title: "Outsource Employees",
        description: "",
        representationType: "Summary",
        dataSourceType: "REPORTING",
        trendDirection: "neutral",
        comparison: { type: "previous_period", field: "financialYear" },
        group_by: ["kpi"],
        flatten_from: ["FR1"],
        formulas: [
          {
            metric_name: "Outsourced Employees",
            formula: "{{DC1}}",
            apply_formula_group_by: ["location_id"],
            group_by: ["metric_name"],
            aggregate: { sum: "value" }
          }
        ],
        dataConfigs: [
          {
            widgetConfig: {
              module: ["Employment"],
              latest: true,
              filters: blank({
                category: ["Employment"],
                sub_category: ["Outsource Employee (in Number)"],
                kpi: ["Outsource Employees"]
              }),
              group_by: ["kpi","location_id","displayPeriods"],
              aggregate: { sum: "value" },
              aggregateSubLocations: true
            }
          }
        ]
      }
    ]
  }
};


// ───────────────── GRAPH CONFIGS ─────────────────

const graphConfigs = {

  "Employment Composition": {
    title: "Employment Composition",
    description: "Distribution of workforce by employment type",
    chartType: "donut",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["kpi"],
    flatten_from: ["FR1"],
    formulas: [
      {
        metric_name: "",
        formula: "{{DC1}}",
        apply_formula_group_by: ["kpi", "location_id"],
        group_by: ["kpi"],
        aggregate: { sum: "value" }
      }
    ],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          latest: true,
          filters: blank({
            category: ["Employment"],
            sub_category: [
              "Full-time Employee (in Number)",
              "Contract Employee (in Number)",
              "Outsource Employee (in Number)"
            ],
            kpi: [
              "Full-time Employees",
              "Contract Employees",
              "Outsource Employees"
            ]
          }),
          group_by: ["kpi", "location_id", "displayPeriods"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  },


  "Employment Trend": {
    title: "Employment Trend",
    description: "Monthly workforce trend by employment type",
    chartType: "area",
    groupChartType: "line",
    representationType: "Graph",
    dataSourceType: "REPORTING",
    group_by: ["displayPeriods","kpi"],
    dataConfigs: [
      {
        widgetConfig: {
          module: ["Employment"],
          filters: blank({
            category: ["Employment"],
            sub_category: [
              "Full-time Employee (in Number)",
              "Contract Employee (in Number)",
              "Outsource Employee (in Number)"
            ],
            kpi: [
              "Full-time Employees",
              "Contract Employees",
              "Outsource Employees"
            ]
          }),
          group_by: ["displayPeriods","kpi"],
          aggregate: { sum: "value" },
          aggregateSubLocations: true
        }
      }
    ]
  }

};


// ───────────────── FINAL CONFIG ─────────────────

const hrsrEmploymentConfig = {
  label: "HRSR-Employment",
  description: "Employment & Workforce Composition Metrics",
  apiKeys: ["employment","hrsr employment","workforce"],
  modules: ["Employment"],
  summaryConfigs,
  graphConfigs
};

export default hrsrEmploymentConfig;